import { Button, Modal } from 'react-bootstrap';
import { useIntl } from 'react-intl';

const HomeCustomModal = ({ showFirstTimeModalHome, setShowFirstTimeModalHome, modalImgUrl }) => {
  const intl = useIntl();

  return (
    <Modal
      size='xl'
      show={showFirstTimeModalHome}
      onHide={() => setShowFirstTimeModalHome(false)}
      centered
    >
      <Modal.Body className='p-0 position-relative custom-home-modal'>
        {modalImgUrl === ''
          ? (
            <div className='image-not-found-modal-home'>{intl.formatMessage({ id: 'custom-home-modal-admin-img-not-found' })}</div>
          )
          : (
            <img
              src={modalImgUrl}
              alt='modal-img'
              className='w-100 img-fluid'
              style={{ display: 'block' }}
            />
          )}
        <Button
          onClick={() => setShowFirstTimeModalHome(false)}
          variant='dark'
          className='position-absolute'
          style={{ bottom: '20px', right: '20px' }}
        >
          OK
        </Button>
      </Modal.Body>
    </Modal>

  );
};

export default HomeCustomModal;
